import styled from 'styled-components';

export const ImageInfo = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const Preview = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 5px;
  background-image: url(${props => props.src});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: 50% 50%;
`;